import { useLingui } from '@lingui/react/macro';
import { Section } from './section';
import { SpacedElements } from './spaced-elements';
import { Title } from './title';

export function PaymentFormTitleBlock() {
  const { t } = useLingui();

  return (
    <Section $classModifier="form-title">
      <SpacedElements>
        <Title>{t`Payment`}</Title>
      </SpacedElements>
    </Section>
  );
}
